<script>

import { API_USER, API_USRE_RECHARFE } from '../../common/api'

export default {
  name: 'UserRecharge',
  props: ["user_id"],
  data () {
    return {
      userRechargeForm: {
        price: ''
      },
      rules: {
        price: [
          { required: true, message: '充值金额不能为空', trigger: 'blur' }
        ],
      },
      user_obj: {
        id: 0,
        number: '',
        name: '',
        balance: ''
      }
    }
  },
  created () {
    this.selectUser()
  },
  methods: {
    selectUser () {
      this.$http.GET(API_USER + '/' + this.user_id, null,
      res => {
        this.user_obj = res.result.data
      }, err => {
        this.$message.error(err.msg)
      })
    },
    recharge (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          let params = {
            money: this.userRechargeForm.price,
            user_id: this.user_id
          };
          this.$http.POST(API_USRE_RECHARFE, params,
          res => {
            this.loading = false;
            this.$emit('rechargeSuccess')
          }, err => {
            this.loading = false;
            this.$message.error(err.msg)
          })
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  }
}
</script>

<template>
  <div>
    <el-form ref="userRechargeForm" :model="userRechargeForm" :rules="rules" size="small" @submit.native.prevent label-width="100px">
      <el-form-item label="用户编号">
        <el-input v-model="user_obj.number" disabled class="rt-input form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="用户名">
        <el-input v-model="user_obj.name" disabled class="rt-input form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="上次结余">
        <el-input v-model="user_obj.balance" disabled class="rt-input form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="充值金额" prop="price">
        <el-input type="number" v-model="userRechargeForm.price" placeholder="请输入充值金额" clearable class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="warning" @click="resetForm('userRechargeForm')" size="small">重 置</el-button>
        <el-button type="primary" @click="recharge('userRechargeForm')" size="small">确 定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<style lang="scss" scoped>

@import '../../assets/styles/table.scss';

</style>



// WEBPACK FOOTER //
// src/page/user/UserRecharge.vue